/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Field_Valid_FromInputs */

const cs_field_valid_from = /** @type {(inputs: Field_Valid_FromInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Platnost od`)
};

const en_field_valid_from = /** @type {(inputs: Field_Valid_FromInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Valid from`)
};

/**
* | output |
* | --- |
* | "Valid from" |
*
* @param {Field_Valid_FromInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const field_valid_from = /** @type {((inputs?: Field_Valid_FromInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Field_Valid_FromInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_field_valid_from(inputs)
	return cs_field_valid_from(inputs)
});